import { render, staticRenderFns } from "./dynamic-form-builder.vue?vue&type=template&id=96f3dcec&scoped=true"
import script from "./dynamic-form-builder.vue?vue&type=script&lang=js"
export * from "./dynamic-form-builder.vue?vue&type=script&lang=js"
import style0 from "./dynamic-form-builder.vue?vue&type=style&index=0&id=96f3dcec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f3dcec",
  null
  
)

export default component.exports